import { toggleCreateReportModalOpened } from '@/states/scenarioBuilder.slice'
import { ExpandMore } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Tooltip,
  Typography,
} from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux'

import { UserPermission } from '@/enums/scenario-builder.enum'
import { useAppSelector } from '@/hooks/use-app-selector'
import { userHasPermission } from '@/services/scenarioBuilder.service'
import { ReportTemplateGrid } from './ReportTemplateGrid'

export const ReportTemplateAccordion: React.FC = () => {
  const dispatch = useDispatch()
  const [expanded, setExpanded] = React.useState<boolean>(true)
  const handleAccordionChange = () => {
    setExpanded(!expanded)
  }
  const hasNewModifiedValues = useAppSelector(
    (s) => s.scenarioBuilder.hasNewModifiedValues,
  )
  const userInfo = useAppSelector((s) => s.scenarioBuilder.userInfo)

  const hasEditTemplatePermission = userHasPermission(
    userInfo,
    UserPermission.EDIT_REPORT_TEMPLATE,
  )
  return (
    <Accordion expanded={expanded} onChange={handleAccordionChange}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Box
          display='grid'
          gridTemplateColumns='1fr auto'
          width='100%'
          alignItems='center'
          padding='1rem 0'
          gap={4}
          boxSizing='border-box'
        >
          <Typography variant='h3'>All Report Templates</Typography>

          {hasEditTemplatePermission && (
            <Tooltip
              placement='top'
              arrow
              title={hasNewModifiedValues ? 'Template changes are pending' : ''}
            >
              <span>
                <Button
                  variant='contained'
                  disabled={hasNewModifiedValues}
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    event.stopPropagation()
                    dispatch(toggleCreateReportModalOpened(true))
                  }}
                >
                  Create New Template
                </Button>
              </span>
            </Tooltip>
          )}
        </Box>
      </AccordionSummary>

      <AccordionDetails>
        <ReportTemplateGrid />
      </AccordionDetails>
    </Accordion>
  )
}
